var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodVeryGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_40_49621)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2727 17.6313C17.2727 19.6494 15.6363 21.2858 13.6182 21.2858C11.6 21.2858 9.96362 19.6494 9.96362 17.6313C9.96362 15.6131 11.6 13.9767 13.6182 13.9767C15.6545 13.9585 17.2727 15.6131 17.2727 17.6313Z",
    fill: "#F757B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0181 17.1956C18.0181 19.2137 16.3817 20.8501 14.3635 20.8501C12.3453 20.8501 10.709 19.2137 10.709 17.1956C10.709 15.1774 12.3453 13.541 14.3635 13.541C16.3817 13.541 18.0181 15.1774 18.0181 17.1956Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0181 17.1962C16.0181 18.1234 15.2726 18.8689 14.3635 18.8689C13.4544 18.8689 12.709 18.1234 12.709 17.1962C12.709 16.2689 13.4544 15.5234 14.3635 15.5234C15.2726 15.5416 16.0181 16.2871 16.0181 17.1962Z",
    fill: "#14110E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7453 16.4511C13.7453 16.8693 13.3998 17.2148 12.9817 17.2148C12.5635 17.2148 12.218 16.8693 12.218 16.4511C12.218 16.033 12.5635 15.6875 12.9817 15.6875C13.3998 15.6875 13.7453 16.0148 13.7453 16.4511Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4365 17.6313C29.4365 19.6494 27.8002 21.2858 25.782 21.2858C23.7638 21.2858 22.1274 19.6494 22.1274 17.6313C22.1274 15.6131 23.7638 13.9767 25.782 13.9767C27.8002 13.9585 29.4365 15.6131 29.4365 17.6313Z",
    fill: "#F757B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1638 17.1956C30.1638 19.2137 28.5275 20.8501 26.5093 20.8501C24.4911 20.8501 22.8547 19.2137 22.8547 17.1956C22.8547 15.1774 24.4911 13.541 26.5093 13.541C28.5275 13.541 30.1638 15.1774 30.1638 17.1956Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.291 17.196C28.291 18.1415 27.5274 18.9233 26.5819 18.9233C25.6364 18.9233 24.8728 18.1597 24.8728 17.196C24.8728 16.2506 25.6364 15.4688 26.5819 15.4688C27.5274 15.4869 28.291 16.2506 28.291 17.196Z",
    fill: "#14110E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9274 16.4146C25.9274 16.851 25.5819 17.1964 25.1456 17.1964C24.7092 17.1964 24.3638 16.851 24.3638 16.4146C24.3638 15.9783 24.7092 15.6328 25.1456 15.6328C25.5819 15.6328 25.9274 15.9783 25.9274 16.4146Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.8364 25.0871C14.8364 27.3053 13.0364 29.1235 10.8182 29.1235C8.60005 29.1235 6.80005 27.3235 6.80005 25.0871C6.80005 22.869 8.60005 21.0508 10.8182 21.0508C13.0364 21.0508 14.8364 22.8508 14.8364 25.0871Z",
    fill: "url(#paint1_radial_40_49621)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.3818 25.0871C33.3818 27.3053 31.5818 29.1235 29.3636 29.1235C27.1455 29.1235 25.3455 27.3235 25.3455 25.0871C25.3455 22.869 27.1455 21.0508 29.3636 21.0508C31.5818 21.0508 33.3818 22.8508 33.3818 25.0871Z",
    fill: "url(#paint2_radial_40_49621)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1453 8.92751C13.2726 9.47296 12.3635 9.98205 11.5271 10.6002C11.1998 10.8366 11.5089 11.3821 11.8362 11.1457C12.6726 10.5275 13.5635 10.0184 14.4544 9.47296C14.7998 9.25478 14.4908 8.70932 14.1453 8.92751Z",
    fill: "#F757B0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1453 8.45485C13.2726 9.0003 12.3635 9.50939 11.5271 10.1276C11.1998 10.3639 11.5089 10.9094 11.8362 10.673C12.6726 10.0548 13.5635 9.54576 14.4544 9.0003C14.7998 8.78212 14.4908 8.23667 14.1453 8.45485Z",
    fill: "#14110E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2181 10.5642C28.0909 11.1097 28.9999 11.6188 29.8363 12.237C30.1636 12.4733 29.8545 13.0188 29.5272 12.7824C28.6909 12.1642 27.7999 11.6551 26.909 11.1097C26.5454 10.8915 26.8727 10.346 27.2181 10.5642Z",
    fill: "#F757B0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2181 10.0913C28.0909 10.6368 28.9999 11.1459 29.8363 11.764C30.1636 12.0004 29.8545 12.5459 29.5272 12.3095C28.6909 11.6913 27.7999 11.1822 26.909 10.6368C26.5454 10.4186 26.8727 9.89132 27.2181 10.0913Z",
    fill: "#14110E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5635 24.4727C12.5635 24.4727 20.3635 27.509 28.1453 24.4727C28.1453 24.4727 26.3817 31.1636 20.7998 31.1817C13.5635 31.1817 12.5635 24.4727 12.5635 24.4727Z",
    fill: "#14110E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0908 24.9453L14.7635 26.5817C14.7635 26.5817 19.5272 29.018 25.4181 26.9089L25.7817 25.1999C20.9272 26.418 16.3817 25.5635 14.0908 24.9453Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40_49621",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.487641,
    stopColor: "#FEC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7389A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_40_49621",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8214 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE278D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#DE278D",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#DE278D",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#DE278D",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#DE278D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#972464",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_40_49621",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3668 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE278D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#DE278D",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#DE278D",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#DE278D",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#DE278D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#972464",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodVeryGood);
export default __webpack_public_path__ + "static/media/Mood_Very-Good.2aac40e44ccc818b3fe73e574b4e385a.svg";
export { ForwardRef as ReactComponent };